export const VISIBLE_OPTIONS_NUMBER = 20;
export const VISIBLE_OPTIONS_NUMBER_FOR_SEARCH = 10;
